<template>
  <div class="disavow-table">
    <v-dialog v-model="groupAssign" width="50%">
      <div class="group-assign-modal-container">
        <v-select :items="users" email="user" item-text="email" chips multiple>
        </v-select>

        <div class="group-assign-selected-links-container">
          <div v-for="link in selected" :key="link.group">
            {{ link.group }}
          </div>
        </div>

        <v-btn>Assign</v-btn>
      </div>
    </v-dialog>
    <v-dialog v-model="sitePreview" width="85%">
      <div class="site-preview-container"></div>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      overlay-color="rgba(0,0,0,0.1)"
      width="85%"
      flat="true"
    >
      <v-toolbar dark color="blue">
        <v-toolbar-title>Group Links</v-toolbar-title>
      </v-toolbar>
      <div class="link-modal-header">
        <BaseFilters
          :headers="headers"
          @filtersUpdated="filtersUpdated"
          @toggleModal="toggleModal"
          :modalData="modalData"
          @fetchLinks="fetchLinks"
        ></BaseFilters>
        <BaseActiveLinkFilters @fetchLinks="fetchLinks"></BaseActiveLinkFilters>
      </div>

      <div class="modal-body">
        <v-data-table
          :items="links"
          :headers="innerHeaders"
          :loading="loading"
          show-select
          v-model="innerSelected"
        >
          <template v-slot:item.created_at="{ item }">
            <div>
              {{ item.created_at | formatDate }}
            </div>
          </template>

          <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | formatDate }}
          </template>

          <template v-slot:item.disavow_status="{ item }">
            <v-btn-toggle
              v-model="item.disavow_status"
              :color="linkStatusColor(item.disavow_status)"
              group
              :mandatory="true"
            >
              <v-btn
                icon
                small
                v-for="(status, name) in linkStatus"
                :key="name"
                :value="name"
                @click="setLinkStatus(item, status)"
              >
                <v-icon small>{{ status.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>

          <template v-slot:item.anchor_text="{ item }">
            <div class="no-wrap">{{ item.anchor_text }}</div>
          </template>

          <template v-slot:item.pre_text="{ item }">
            <div class="no-wrap">{{ item.pre_text }}</div>
          </template>

          <template v-slot:title_tag="{ item }">
            <div class="no-wrap">{{ item.title_tag }}</div>
          </template>

          <template v-slot:item.id="{ item }">
            {{
              links
                .map(function(x) {
                  return x.id;
                })
                .indexOf(item.id) + 1
            }}
          </template>
        </v-data-table>
      </div>
      <div class="d-flex align-center justify-space-between">
        <div>
          <v-menu
            :offset-y="true"
            v-if="innerSelected.length > 0"
            transition="scroll-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="secondary" v-bind="attrs" v-on="on"
                ><v-icon left>mdi-checkbox-multiple-marked</v-icon>Bulk Update
                ({{ innerSelected.length }})</v-btn
              >
            </template>
            <v-list nav dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Bulk Link Actions</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-for="(status, name) in linkStatus"
                :key="name"
                @click="bulkLinkStatus(name)"
              >
                <v-list-item-icon class="mr-4">
                  <v-icon v-text="status.icon" :color="status.color"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{
                  name | capitalize
                }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-dialog>
    <header class="disavow-table__header">
      <div class="d-flex justify-space-between align-center  ">
        <ICTabs></ICTabs>
        <div class="ml-8 d-flex flex-nowrap">
          <BaseGroupsFilters
            :headers="headers"
            @filtersUpdated="filtersUpdated"
          ></BaseGroupsFilters>

          <BaseColumnVisibility
            @columnVisibility="columnVisibilityUpdated"
            :headers="headers"
            :innerHeaders="innerHeaders"
          />
          <BaseRules :headers="headers" @rulesUpdated="rulesUpdated">
          </BaseRules>
        </div>
      </div>
      <div class="d-flex align-center flex-row-reverse">
        <BaseActiveFilters class="mw-50" @filtersUpdated="filtersUpdated" />
      </div>
    </header>

    <v-data-table
      id="data-table"
      class="disavow-table__content"
      :items="groups"
      :headers="visibleHeaders"
      :loading="loading"
      :options.sync="tableOptions"
      :item-class="itemRowBackground"
      :serverItemsLength="itemsPerPage"
      item-key="id"
      show-select
      hide-default-footer
      v-model="selected"
    >
      <template v-slot:item.created_at="{ item }">
        <div>
          {{ item.created_at | formatDate }}
        </div>
      </template>

      <template v-slot:item.updated_at="{ item }">
        {{ item.updated_at | formatDate }}
      </template>

      <template v-slot:item.status="{ item }">
        <v-btn-toggle
          v-model="item.status"
          :color="domainStatusColor(item.status)"
          group
          :mandatory="false"
        >
          <v-btn
            icon
            small
            v-for="(status, name) in domainStatus"
            :key="name"
            :value="name"
            @click="setDisavowStatusHelp(item, name)"
          >
            <v-icon small>{{ status.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>

      <template v-slot:item.domain="{ item }">
        <div class="no-wrap">
          {{ item.domain }}
        </div>
      </template>

      <template v-slot:item.group="{ item }">
        <span class="no-wrap">
          <a
            :href="itemLink(item.group)"
            target="_blank"
            class="url indigo--text"
            >{{ item.group }}</a
          >
        </span>
        <v-btn
          @click="toggleModal(item)"
          class="mx-2"
          fab
          x-small
          style="float: right"
          >...</v-btn
        >
      </template>

      <template v-slot:item.id="{ item }">
        {{ groupIds.indexOf(item.id) + (pageNumber - 1) * itemsPerPage + 1 }}
      </template>

      <template v-slot:item.assignee_id="{ item }">
        {{
          item.assignee_id
            ? users.filter((user) => {
                if (user.id == item.assignee_id) {
                  return user.name;
                }
              })[0].name
            : null
        }}
      </template>

      <template v-slot:item.updated_by="{ item }">
        {{
          item.updated_by
            ? users.filter((user) => {
                if (user.id == item.updated_by) {
                  return user.name;
                }
              })[0].name
            : null
        }}
      </template>
    </v-data-table>

    <div class="d-flex align-center justify-space-between px-2 py-4">
      <div>
        <v-menu
          :offset-y="true"
          v-if="selected.length > 0"
          transition="scroll-y-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on"
              ><v-icon left>mdi-checkbox-multiple-marked</v-icon>Bulk Update ({{
                selected.length
              }})</v-btn
            >
          </template>
          <v-list nav dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Bulk Domain Actions</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-for="action in bulkDomainActions"
              :key="action.title"
              @click="handleBulkActions(action)"
            >
              <v-list-item-icon class="mr-4">
                <v-icon v-text="action.icon" :color="action.color"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ action.title }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="d-flex align-center">
        <small class="mr-3">Links per page:</small>

        <div class="itemsPerPageSelector">
          <v-select
            v-model="itemsPerPage"
            :items="[25, 50, 100, 250]"
            outlined
            dense
            class="flex-grow-0"
            hide-details="auto"
          ></v-select>
        </div>
        <div class="pagination-container">
          <Pagination
            :calculatePages="calculatePages"
            :setPageNumber="setPageNumber"
            :pageNumber="pageNumber"
          />
          <v-btn :disabled="hasPrevPage" text icon rounded @click="prevPage()"
            ><v-icon>mdi-chevron-left</v-icon></v-btn
          >

          <v-btn
            :disabled="hasNextPage"
            class="ml-2"
            text
            icon
            rounded
            @click="nextPage()"
            ><v-icon>mdi-chevron-right</v-icon></v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/";

import moment from "moment";
import { mapState } from "vuex";

import ICTabs from "@/components/ICTabs.vue";
import Pagination from "@/components/Pagination.vue";
import BaseGroupsFilters from "@/components/BaseGroupsFilters.vue";

import APIService from "@/services/APIService.js";

export default {
  components: {
    ICTabs,
    Pagination,
    BaseGroupsFilters,
  },
  data() {
    return {
      dialog: false,
      users: [],
      currentUser: this.$store.getters["user/userInfo"],
      groupAssign: false,
      currentRoute: this.$route.path,
      modalData: {},
      sitePreview: false,

      pageNumber: 1,
      fetchGroupsConfig: {
        project_id: null,
        disavow_status: null,
        limit: 25,
        orderBy: "id",
        orderDir: "asc",
        before_id: null,
        after_id: null,
        assigned: true,
        page: 1,
      },
      //the assigned ^^ attribute is just do determine if we care if the groups/links are unassigned.
      fetchLinksConfig: {
        project_id: null,
        disavow_status: null,
        limit: 25,
        orderBy: "id",
        orderDir: "asc",
        before_id: null,
        after_id: null,
        group_id: null,
      },
      itemsPerPage: 25,
      options: {},
      project: null,
      projectName: null,
      loading: true,
      visibleColumns: null,
      tableOptions: {},
      visibleHeaders: [],
      dateFormat: "MM/DD/YYYY",
      linkStatus: {
        disavowed: {
          color: "red darken-2",
          status: "disavowed",
          icon: "mdi-thumb-down",
        },
        approved: {
          color: "green darken-2",
          status: "approved",
          icon: "mdi-thumb-up",
        },
        review: {
          color: "yellow darken-2",
          status: "review",
          icon: "mdi-help-circle",
        },
        unassigned: {
          color: "blue darken-2",
          icon: "mdi-alert-circle",
          status: "unassigned",
        },
      },

      bulkDomainActions: {
        approveGroups: {
          title: "Approve Groups",
          color: "green darken-2",
          icon: "mdi-circle",
          disavow_type: "domain",
          status: "approved",
          purpose: "status",
        },

        reviewGroups: {
          title: "Review Groups",
          color: "yellow darken-2",
          icon: "mdi-help-circle",
          disavow_type: "domain",
          status: "review",
          purpose: "status",
        },

        disavowGroups: {
          title: "Disavow Groups",
          color: "red darken-2",
          icon: "mdi-close-octagon",
          disavow_type: "domain",
          status: "disavowed",
          purpose: "status",
        },
      },
      domainStatus: {
        disavowed: {
          color: "red darken-2",
          icon: "mdi-thumb-down",
        },
        approved: {
          color: "green darken-2",
          icon: "mdi-thumb-up",
        },
        review: {
          color: "yellow darken-2",
          icon: "mdi-help-circle",
        },
      },
      filters: {},
      initial: true,
      selected: [],
      innerSelected: [],
    };
  },
  watch: {
    $route: {
      handler: function() {
        store.dispatch("project/setCurrentUrl", this.$route);

        this.resetPages();
      },

      deep: true,
      immediate: true,
    },

    tableOptions() {
      if (!this.initial) {
        let options = this.tableOptions;

        this.fetchGroupsConfig.orderBy =
          options.sortBy.length > 0 ? options.sortBy[0] : "ID";

        this.fetchGroupsConfig.orderDir =
          options.sortDesc.length && options.sortDesc[0] ? "desc" : "asc";

        if (this.fetchGroupsConfig.orderBy === "id") {
          this.fetchGroupsConfig.orderBy = "ID";
        }

        let orderAndDirObject = {
          order: this.fetchGroupsConfig.orderBy,
          direction:
            options.sortDesc.length && options.sortDesc[0] ? "desc" : "asc",
        };
        store.dispatch("project/setCurrentSortAndDir", orderAndDirObject);
        this.resetTable();
        console.log(this.fetchGroupsConfig);
        this.fetchGroups();
      } else {
        this.initial = false;
      }
    },
    itemsPerPage() {
      this.fetchGroupsConfig.limit = this.itemsPerPage;
      //this.fetchGroupsConfig.after_id = this.links[0].id - 1;

      this.resetTable();
      this.fetchGroups();

      //this.fetchGroupsConfig.after_id = null;
    },
    visibleColumns() {
      this.visibleHeaders = [];
      this.headers.forEach((header) => {
        if (this.visibleColumns.includes(header.text)) {
          this.visibleHeaders.push(header);
        }
      });
    },
  },
  mounted() {
    APIService.getUsers(this.fetchGroupsConfig.project_id).then((res) => {
      let theUsers = res.data.results;
      console.log(this.$store);
      this.$store.dispatch("users/setUsers", res.data.results);

      this.users = theUsers;
    });
  },
  filters: {
    formatDate: function(date) {
      if (!date) return "";
      return moment(date).format("MM/DD/YYYY");
    },
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    resetPages() {
      console.log("reset pages");
      this.fetchGroupsConfig.page = 1;
      this.pageNumber = 1;
    },
    setPageNumber(page) {
      if (!this.loading) {
        this.fetchGroupsConfig.page = page;
        this.pageNumber = page;
        console.log(page);
        this.fetchGroups();
      }
    },
    calculatePages() {
      let pageCount = 0;
      let currentTab = this.$route.params.status;
      let theCounts = store.getters["project/counts"];
      pageCount = Math.ceil(theCounts[currentTab] / this.itemsPerPage);
      return pageCount;
    },
    fetchCounts() {
      let theCounts = store.getters["project/counts"];
      console.log(theCounts);
    },
    handleBulkActions(action) {
      if (action.purpose === "assign") {
        this.groupAssign = true;
      } else {
        this.bulkDomainStatus(action);
        console.log(action);
      }
    },

    toggleModal(item) {
      console.log(item);
      this.fetchLinksConfig.group_id = item.id;
      this.fetchLinksConfig.disavow_status = item.status;
      this.fetchLinksConfig.assigned = true;
      this.fetchLinksConfig.project_id = item.project_id;
      this.fetchLinksConfig.limit = item.num_links;
      this.dialog = true;
      this.fetchLinks();
      console.log(this.links);
    },
    nextPage() {
      if (!this.loading) {
        /* let after_link = this.links[this.links.length - 1];
        let after_id = after_link.id;

        this.fetchGroupsConfig.after_id = after_id;

        this.resetTable();
        this.fetchGroups();

        this.fetchGroupsConfig.after_id = null;*/
        this.fetchGroupsConfig.page++;
        this.pageNumber++;
        this.fetchGroups();
      }
    },
    prevPage() {
      if (!this.loading) {
        /*  let before_link = this.links[0];
        let before_id = before_link.id;

        this.fetchGroupsConfig.before_id = before_id;

        this.resetTable();
        this.fetchGroups();

        this.fetchGroupsConfig.before_id = null;*/

        if (this.fetchGroupsConfig.page - 1 <= 1) {
          this.fetchGroupsConfig.page = 1;
        } else {
          this.fetchGroupsConfig.page--;
        }
        this.pageNumber = this.fetchGroupsConfig.page;
        this.fetchGroups();
      }
    },
    fetchLinks() {
      console.log(this.fetchLinksConfig);
      store
        .dispatch("project/fetchLinks", {
          config: this.fetchLinksConfig,
        })
        .then((res) => {
          console.log(res);
          this.loading = false;
        });
    },
    fetchGroups() {
      console.log(this.$route);
      console.log(store.getters["project/currentUrl"]);
      console.log(this.fetchGroupsConfig);
      store
        .dispatch("project/fetchGroups", {
          config: this.fetchGroupsConfig,
        })
        .then(() => {
          this.loading = false;
          this.itemRowBackgroundHelp();
        });
    },
    resetTable() {
      this.loading = true;
      store.dispatch("project/clearLinks");
    },
    columnVisibilityUpdated(value) {
      this.visibleColumns = value;
    },
    filtersUpdated() {
      this.fetchGroups();
    },
    rulesUpdated() {
      //Delete the color property before posting again
      this.itemRowBackgroundHelp();
      //this.fetchGroups(); // doesnt seem to work
    },
    linkStatusColor(status) {
      return this.linkStatus[status].color;
    },
    domainStatusColor(status) {
      if (
        status !== "myNew" &&
        status !== "allNew" &&
        status !== "unassigned"
      ) {
        return this.domainStatus[status].color;
      } else return "white";
    },
    bulkDomainStatus(domainStatus) {
      this.loading = true;
      let selectedLinks = this.selected.map(function(item) {
        return item;
      });

      let sessionChangeObject = {
        selectedLinks: selectedLinks,
        type: "bulk",
        oldStatus: selectedLinks[0].status,
        newStatus: domainStatus.status,
        project_id: this.fetchGroupsConfig.project_id,
      };

      console.log(selectedLinks[0].status);

      let theOldData = {
        groups: selectedLinks,
        disavow_type: domainStatus.disavow_type,
        status: domainStatus.status,
        project_id: this.fetchGroupsConfig.project_id,
      };

      console.log(theOldData);

      let newDataTest = [...theOldData.groups];
      newDataTest.forEach((item) => {
        item.status = domainStatus.status;
        delete item.num_links;
        delete item.color;
        item.updated_by = this.$route.params.user;
        return item;
      });

      APIService.updateDomains(newDataTest)
        .then((res) => {
          console.log(res);
          const notification = {
            type: domainStatus.status,
            message: `${this.selected.length} domains set to <i>${domainStatus.status}</i>`,
          };
          store.dispatch("sessionHistory/addChange", sessionChangeObject);
          store.dispatch("notification/add", notification, { root: true });
          console.log(res);
          this.selected = [];
          this.fetchGroups();
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Bulk Update Error",
          };
          store.dispatch("notification/add", notification, { root: true });
          console.log(error);
        });
    },
    bulkLinkStatus(status) {
      console.log(status);
      let oldStatus = this.innerSelected[0].disavow_status;
      let newStatus = status;

      let selectedLinks = this.innerSelected.map(function(item) {
        item.disavow_status = status;
        return { id: item.id, disavow_status: status };
      });

      console.log(this.innerSelected);

      let sessionChangeObject = {
        urls: this.innerSelected,
        links: selectedLinks,
        type: "bulk-link",
        oldStatus: oldStatus,
        newStatus: newStatus,
        project_id: this.fetchGroupsConfig.project_id,
      };

      console.log(sessionChangeObject);

      APIService.updateLinks(selectedLinks)
        .then(() => {
          const notification = {
            type: status,
            message: `${this.innerSelected.length} links set to <i>${status}</i>`,
          };
          store.dispatch("notification/add", notification, { root: true });
          store.dispatch("sessionHistory/addChange", sessionChangeObject);

          this.innerSelected = [];
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Bulk Update Error",
          };

          store.dispatch("notification/add", notification, { root: true });
          console.log(error);
        });
    },
    setLinkStatus(item, status) {
      console.log(status.status);
      console.log(item);
      let oldStatus = item.disavow_status;
      let newLinkItem = { ...item };
      console.log(newLinkItem);
      newLinkItem.disavow_status = status.status;
      let sessionChangeObject = {
        link: newLinkItem,
        type: "single-link",
        oldStatus: oldStatus,
        newStatus: status.status,
        project_id: this.fetchGroupsConfig.project_id,
      };

      APIService.updateLink(newLinkItem)
        .then((response) => {
          store.dispatch("sessionHistory/addChange", sessionChangeObject);
          console.log(response);
          let response_data = JSON.parse(response.config.data);
          console.log(response_data);
          const notification = {
            type: response_data.disavow_status,
            message: `Link Status set to <i>${response_data.disavow_status}</i>:`,
            details: response_data.url,
          };

          store.dispatch("notification/add", notification, { root: true });
        })
        .catch((error) => {
          const notification = {
            type: "error",
            message: "Error updating <i>Link Status</i> for:",
            details: item.url,
          };
          store.dispatch("notification/add", notification, { root: true });
          console.log(error);
        });
    },
    setDisavowStatusHelp(item, status) {
      console.log(item);
      console.log(status);
      if (item.status != status) {
        let sessionChangeObject = {
          item: item,
          status: status,
          type: "single",
        };

        store.dispatch("sessionHistory/addChange", sessionChangeObject);
        this.setDisavowStatus(item, item.id, item.type, status);

        //Still needs to call this.setDisavowStatus
      }
    },

    setDisavowStatus(item, link_id, type, status) {
      console.log(status);
      delete item.num_links;
      delete item.color;
      item.updated_by = this.$route.params.user;
      if (link_id && type && status != undefined) {
        this.loading = true;
        APIService.setDisavowStatus(item, link_id, type, status)

          .then((res) => {
            const notification = {
              type: status,
              message: `Group Status set to <i>${status}</i>`,
              details: item.group,
            };
            console.log(item.group);
            console.log(res);

            store.dispatch("notification/add", notification, { root: true });

            this.fetchGroups();
          })
          .catch((e) => {
            console.log(e);
            console.error(
              "There was an error with setDisavowStatus",
              link_id,
              type,
              status
            );
          });
      }
    },
    getProjectByID(id) {
      var project = this.projects.filter((project) => {
        return project.id === parseInt(id);
      });

      return project[0];
    },
    getProjectNameByID(id) {
      var project = this.getProjectByID(id);
      return project.name;
    },
    initProject(id, status) {
      this.project = this.getProjectByID(id);
      this.projectName = this.getProjectNameByID(id);

      this.$emit("currentProject", this.projectName);
      this.fetchGroupsConfig.assignee_id = this.currentUser.user;
      this.fetchGroupsConfig.page = 1;
      this.fetchGroupsConfig.project_id = id;
      console.log(status);
      if (status == "allNew") {
        this.fetchGroupsConfig.disavow_status = "unassigned";
        this.fetchGroupsConfig.assigned = "false";

        //this.fecthGroupsConfig.allNew = true;
      } else if (status == "myNew") {
        this.fetchGroupsConfig.disavow_status = "unassigned";
        this.fetchGroupsConfig.assigned = "true";
      } else if (status == "unassigned") {
        this.fetchGroupsConfig.assigned = "true";
        this.fetchGroupsConfig.disavow_status = "unassigned";
      } else {
        this.fetchGroupsConfig.disavow_status = status;
        this.fetchGroupsConfig.assigned = "true";
      }
    },
    itemRowBackgroundHelp() {
      let changedGroups = [...this.groups];
      changedGroups.forEach((item) => {
        let result = "default-link";

        this.rules.forEach((rule) => {
          for (const property in item) {
            if (rule[property] !== undefined) {
              //only do shared properties

              if (
                rule[property] !== null &&
                item[property] !== null &&
                item[property].includes(rule[property])
              ) {
                //check if row breaks the rule

                if (result !== "bad-link") {
                  result = rule.ruleType ? "good-link" : "bad-link";
                }
              }
            }
          }
        });

        //this.groups[index].color = result;

        item.color = result;
      });

      store.dispatch("project/setGroups", changedGroups);
      console.log(changedGroups);
      console.log("trying this out");
    },
    itemRowBackground(item) {
      if (item.color) {
        return item.color;
      }
      return "default-link";
    },
    itemLink(name) {
      return "http://" + name + "/";
    },
  },
  created() {
    this.initProject(
      this.$route.params.id,
      this.$route.params.status,
      this.$route.params.user
    );

    this.fetchGroups();
  },
  beforeRouteUpdate(to, from, next) {
    if (to !== from && !this.loading) {
      this.resetTable();
      this.initProject(to.params.id, to.params.status, to.params.user);
      this.fetchGroups();

      this.selected = [];
      next();
    } else {
      next(false);
    }
  },
  computed: {
    ...mapState({
      projects: (state) => state.projects.projects,
      links: (state) => state.project.links,
      groups: (state) => state.project.groups,
      assignees: (state) => state.project.assignees,
      hasNextPage: (state) => state.project.next_page,
      hasPrevPage: (state) => state.project.prev_page,
      headers: (state) => state.project.headers,
      innerHeaders: (state) => state.project.innerHeaders,
      rules: (state) => state.rules.rules,
    }),
    groupIds() {
      return this.groups.map((x) => x.id);
    },
  },
};
</script>

<style lang="scss">
@import "../assets/temp.css";

.good-link {
  background-color: #d3f5d5 !important;
}
.bad-link {
  background-color: #f5d5db !important;
}

.default-link {
  background-color: white;
}

.modal_btn {
  float: right;
}

#data-table {
  th {
    border-top: 1px solid #e0e0e0;
  }
  tr:hover {
    td {
      &:nth-child(1) {
        background: #eeeeee;
      }
    }
  }

  td {
    border-bottom: 1px solid #e0e0e0;

    &:nth-child(1) {
      position: sticky;
      left: 0;
      background: #fff;
      z-index: 1;
    }

    &:nth-child(2) {
      position: sticky;
      left: 57px;
      background: #fff;
      z-index: 1;
    }

    &:nth-child(3) {
      position: sticky;
      left: 114px;
      background: #fff;
      z-index: 1;
      box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
        0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
        0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
    }
  }
  td,
  th {
    border-right: 1px solid #e0e0e0;
    white-space: nowrap;
  }
}

.v-data-table-header {
  th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: white;
    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04),
      0 0.125rem 0.25rem rgba(0, 0, 0, 0.02),
      0 0.25rem 0.5rem rgba(0, 0, 0, 0.01);

    &:first-child {
      left: 0;
      z-index: 3;
      box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
        0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
        0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
    }

    &:nth-child(2) {
      left: 57px;
      z-index: 3;
      box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
        0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
        0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
    }
    &:nth-child(3) {
      left: 114px;
      z-index: 3;
      box-shadow: 0.0625rem 0 0.125rem rgba(0, 0, 0, 0.04),
        0.125rem 0 0.25rem rgba(0, 0, 0, 0.02),
        0.25rem 0 0.5rem rgba(0, 0, 0, 0.01);
    }
  }

  th {
    white-space: nowrap;
  }
}

.disavow-table {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.disavow-table__header {
  flex: 0 0 auto;
  padding: 1rem 1.5rem;
  position: relative;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04),
    0 0.125rem 0.25rem rgba(0, 0, 0, 0.02), 0 0.25rem 0.5rem rgba(0, 0, 0, 0.01);
  z-index: 2;
}

.disavow-table__content {
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .v-data-table__wrapper {
    flex: 1 1 auto;
    overflow: auto;
  }
  .v-data-footer {
    flex: 0 0 auto;
  }
}
</style>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;

  a {
    max-width: 50rem;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
  }
}
h1 {
  font-size: 1.25rem;
}
.itemsPerPageSelector {
  max-width: 5.5rem;
  margin-right: 1rem;
}

.modal-body {
  position: relative;
  background-color: white;
  height: 70vh;
  padding: 10px;
}

.site-preview-container {
  position: relative;
  width: 100%;
  height: 500px;
}

.open-links-button {
  position: absolute;
  box-shadow: 0px 0px 1px 1px gray;
  padding: 5px;
  bottom: 10px;
}

.group-assign-modal-container {
  position: relative;
  height: 400px;
  padding: 20px;
  background-color: white;
}

.pagination-container {
  display: flex;
  width: 300px;
  justify-content: space-between;
}

.page-number-block {
  background-color: white;
  box-shadow: 0px 0px 2px 2px gray;
  padding: 8px;
  border-radius: 3px;
  transition: 0.3s;
}

.page-number-block:hover {
  cursor: pointer;
  background-color: gray;
  color: white;
}

.group-assign {
  display: inline-block;
  margin-right: 5px;
  background-color: #bdc3c7;
  padding: 3px 20px;
  border-radius: 20px;
  margin-top: 10px;
}

.bulk-assign-loader {
  position: absolute;
  right: 10px;
  top: 10px;
}

.link-modal-header {
  background-color: white;
}
</style>
